import { createSlice } from '@reduxjs/toolkit';

export interface dtcState {
  data: any[];
  isLoading: boolean;
}

const initialState: dtcState = {
  data: [],
  isLoading: true,
};

export const dtcSlice = createSlice({
  name: 'dtc',
  initialState,
  reducers: {
    getAll(state, { payload }) {
      return {
        data: payload,
        isLoading: false,
      };
    },
  },
});

export const { getAll } = dtcSlice.actions;
export default dtcSlice.reducer;
